<template>
  <div class="menuList" v-if="listHotClass && listHotClass.length > 0">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, index) in listHotClass"
        :key="index"
        :label="item.ClassName"
        :name="menuList[index]"
      >
        <div
          class="list"
          v-if="listHotProducts.product && listHotProducts.product.length > 0"
        >
          <div
            class="product"
            v-for="(item, idx) in listHotProducts.product"
            @click="toDetail(item.ProductNumber, item.ShopId)"
            :key="idx"
          >
            <div class="image">
              <el-image
                :src="imgUrlFilter(item.ProductPhoto)"
                fit="contain"
              ></el-image>
            </div>
            <div class="title">
              <div class="discount" v-if="item.IsCouponProduct">
                {{ $t("B2C.discount") }}
              </div>
              <div class="brand" v-if="item.IsBrandProduct">
                {{ $t("B2C.brand") }}
              </div>
              <div class="attestation" v-if="item.IsAttestationProduct">
                {{ $t("B2C.attestation") }}
              </div>
              <span class="name">{{ item.ProductName }}</span>
            </div>
            <div class="desc">{{ item.Descriptions }}</div>
          </div>
        </div>
        <div v-else>
          <el-empty
            :description="$t('B2C.noData')"
            :image-size="100"
            style="text-align: center"
          ></el-empty>
        </div>
        <div class="menu-pagination">
          <el-pagination
            :current-page="pageIndex"
            :page-sizes="[50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listHotProducts.totalCount"
            @size-change="sizeChange"
            @current-change="currentChange"
          />
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
export default {
  name: "MenuList",
  components: {},
  props: {
    listHotClass: {
      type: Array,
    },
    listHotProducts: {
      type: Object,
    },
  },
  data() {
    return {
      menuList: ["first", "second", "third", "fourth", "fifth"],
      activeName: "first",
      className: "",
      pageIndex: 1,
      pageSize: 50,
    };
  },
  mounted() {},
  methods: {
    toDetail(productNumber, shopId) {
      let routeUrl = this.$router.resolve({
        path: "/details",
        query: { ProductNumber: productNumber, ShopId: shopId },
      });
      window.open(routeUrl.href, "_blank");
    },
    sizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    currentChange(val) {
      this.pageIndex = val;
      this.getList();
    },
    getList() {
      this.$emit("loadMenuProduct", {
        className: this.className,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      });
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value.split("|")[0]);
    },
    handleClick(tab) {
      if (tab.name == "first") {
        this.className = "";
      } else {
        this.className = tab.label;
      }
      this.pageIndex = 1;
      this.pageSize = 50;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.menuList {
  padding: 3%;
  .el-tabs__nav {
    margin: auto;
    width: 100%;
    text-align: center;
    border: none !important;
  }
  .el-tabs__header {
    border: none !important;
    margin: 0;
  }
  .el-tab-pane {
    text-align: center;
  }
  .el-tabs__item {
    min-width: 200px;
    text-align: center;
    margin: 10px 0px 10px 10px;
    height: auto;
    line-height: 2;
    color: #666;
    background: #f5f5f5;
    border: 1px solid #f5f5f5 !important;
  }
  .el-tabs__item.is-active {
    color: #fff;
    background: #01aaa3;
    border: 1px solid #01aaa3 !important;
  }
  .el-empty {
    margin-top: 2%;
    margin-bottom: 2%;
    .el-empty__image {
      margin: auto;
    }
    p {
      font-size: 14px;
      color: #999;
    }
  }
  .list {
    width: 80%;
    margin-left: 2%;
    text-align: left;
    display: inline-block;
    overflow: hidden;
    .product {
      display: inline-block;
      margin-top: 2%;
      margin-right: 2%;
      border: 10px solid #fff;
      background: #fff;
      width: 18%;
      overflow: hidden;
      text-align: center;
      cursor: pointer;
      .image {
        background: rgb(244, 245, 246);
        vertical-align: middle;
        .el-image {
          width: 200px;
          height: 200px;
        }
      }
      .title {
        font-weight: bold;
        margin: 10px auto;
        padding: 0;
        width: 90%;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        .discount {
          vertical-align: middle;
          display: inline-block;
          background: red;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .brand {
          vertical-align: middle;
          display: inline-block;
          background: #e6a23c;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .attestation {
          vertical-align: middle;
          display: inline-block;
          background: #22b196;
          color: white;
          padding: 0px 2px;
          border-radius: 2px;
          font-size: 12px;
          margin-right: 5px;
        }
        .name {
          white-space: nowrap;
          overflow: hidden;
          vertical-align: middle;
        }
      }
      .desc {
        margin: 11px auto;
        padding: 0;
        width: 90%;
        font-size: 13px;
        line-height: 15px;
        height: 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .menu-pagination {
    color: #777777;
    font-size: 10px;
    text-align: right;
    margin-top: 3%;
    margin-right: 10%;
  }
}
</style>
